// services/kontoPartners.js — контрагентите към Конто: кой е измислен Булстат,
// списъкът на кодовете от Конто и еднократното почистване на кодовете, които
// старият експорт сам даваше (ПРОМТ-28, 27.10.2026).
//
// Решението на Макс (ОТГОВОР-ПРОМТ-27, 27.10.2026): качването към Конто е
// САМО „Импорт на записвания" (TXT), един файл; CRM-ът НЕ измисля кодове.
// Конто намира контрагента по кода в партидата или по ЕИК (PARTNER_ID), а
// нов създава сам с код по своята номерация (макс + 1, напр. 1005). Кодът
// влиза в CRM-а при следващия „Внос от Конто" (services/kontoSync.js).
//
// Дотогава (16–27.10) експортът даваше на нов клиент свободен код с дължината
// на фирмата и го пращаше в Excel за „Импорт на номенклатури" ПРЕДИ статиите.
// Тези кодове са отбелязани с crm: true в company.konto_partners.customer.
// Конто не ги познава — или, по-лошо, междувременно ги е дал на друг
// контрагент: с такъв код в партидата статията отива на чужд клиент. Затова
// при старта се изчистват от контактите и от списъка (cleanupInventedCodes).

const MAX_KNOWN = 20000;

const norm = (s) => String(s == null ? '' : s).trim().toLowerCase();
const normEik = (s) => String(s == null ? '' : s).replace(/\s+/g, '');

// Измислен Булстат: 999999999 / 9999999999 (и нулите) се пише в Конто на
// физически лица, „Население", Amazon… (ОТГОВОР-ПРОМТ-21). Той не е
// фирма — по него НЕ се търси съвпадение, иначе всеки клиент без ЕИК би
// получил кода на „Население". Таблицата от всички фирми (27.10) има и
// по-дълги: 99999999999999 — затова „само деветки/нули, поне 9".
function isFakeEik(s) {
  const e = normEik(s);
  return /^(9{9,}|0{9,})$/.test(e);
}

// Чисти списъка за запис: [{ c, e }] с непразен код, до 20 знака, без
// повторени кодове. Хвърля при прекалено дълъг списък.
function sanitizeKnown(list) {
  if (!Array.isArray(list)) throw new Error('Списъкът с кодовете липсва.');
  if (list.length > MAX_KNOWN) throw new Error('Списъкът е по-дълъг от ' + MAX_KNOWN + ' реда.');
  const seen = new Set();
  const out = [];
  for (const x of list) {
    const c = String((x && (x.c != null ? x.c : x.code)) || '').trim().slice(0, 20);
    if (!c || seen.has(norm(c))) continue;
    seen.add(norm(c));
    out.push({ c, e: normEik(x && (x.e != null ? x.e : x.eik)).slice(0, 20) });
  }
  return out;
}

// Еднократно, при старта на сървъра (server.js): кодовете с crm: true падат
// от „Счетоводен шифър" на контактите на същата фирма и от списъка. Пипа се
// само acc_code — списъкът е на клиентите (85). Връща броя изчистени
// контакти; второ пускане не прави нищо.
function cleanupInventedCodes(db) {
  let cleaned = 0;
  const contacts = db.all('contacts');
  for (const co of db.all('companies')) {
    const kp = co && co.konto_partners;
    const list = kp && Array.isArray(kp.customer) ? kp.customer : null;
    if (!list || !list.some((x) => x && x.crm)) continue;
    const invented = new Set(list.filter((x) => x && x.crm).map((x) => norm(x.c)));
    for (const c of contacts) {
      if (Number(c.company_id) !== Number(co.id)) continue;
      if (c.acc_code && invented.has(norm(c.acc_code))) { db.update('contacts', c.id, { acc_code: '' }); cleaned++; }
    }
    db.update('companies', co.id, { konto_partners: Object.assign({}, kp, { customer: list.filter((x) => !(x && x.crm)) }) });
  }
  return cleaned;
}

module.exports = { isFakeEik, sanitizeKnown, cleanupInventedCodes };
